import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton", "nameInput"]

  submitStart() {
    if (this.hasSubmitButtonTarget) this.submitButtonTarget.disabled = true
  }

  reset() {
    if (this.hasSubmitButtonTarget) this.submitButtonTarget.disabled = false
    if (this.hasNameInputTarget) this.nameInputTarget.value = ""
  }
}
